import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '../../product/components/templates/Layout'
import CustomTable from '../../product/components/molecules/CustomTable'
import CustomSearch from '../../product/components/molecules/CustomSearch'
import { Button, Dialog } from '@mui/material'
import { handleRedirectInternal } from '../../product/common/components'
import { useFormik } from 'formik'
import AlertContext from '../../product/context/alert/alertContext'
import CommunicationContext from '../../product/context/communication/communicationContext'
import SettingContext from '../../product/context/setting/settingContext'
import ProductCommonContext from '../../product/context/common/commonContext'
import * as Yup from 'yup'
import FullScreenPopup from '../../product/components/organisms/FullScreenPopup'
import SecondaryButton from '../../product/components/atoms/SecondaryButton'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import Loaders from '../../product/components/molecules/Loaders'
import { mapData } from '../../product/common/components'

const SubscribeInfo = (props) => {
    const alertContext = useContext(AlertContext)
    const communicationContext = useContext(CommunicationContext)
    const { allCountries, allStates } = useContext(ProductCommonContext)
    const settingcontext = useContext(SettingContext)
    const [reload, setReload] = useState(false)

    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const { setAlert } = alertContext

    const {
        searchTableAction,
        searchTable,
        table_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseSetting,
    } = settingcontext

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        action: '',
    })

    let action = props.match.params.action

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id, action: action })
        } else {
            setManage({ popup, status: 'new', id: 0, action: action })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            searchterm: '',
            page: 1,
            limit: 20,
            count: 1,
            order: '',
            orderby: '',
            filters: {
                email: {
                    value: '',
                    type: 'like',
                    field: 'cou.email',
                },
            },
            table: 'contact_us',
        },
        onSubmit: (values) => {
            values.filters.email.value = values.email
            setIsLoading(true)
            searchTable(values)
        },
    })
    useEffect(() => {
        formik.handleSubmit()
        return () => {
            formik.values.filters.email.value = ''
        }
    }, [])

    useEffect(() => {
        if (table_data && table_data.records) {
            setTableBody(table_data.records.length ? table_data.records : [])
            setIsLoading(false)
        }
    }, [table_data])
    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.action = action
        formik.values.page = 1
        formik.values.searchterm = ''
        //getAllSearchTemplates(formik.values)
        searchTable(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    const onClickEdit = (id) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    const tableValues = [
        {
            field: 'first_name',
            type: '',
            sort: true,
            disablePadding: false,
            label: 'First Name',
        },
        {
            field: 'last_name',
            type: '',
            sort: true,
            disablePadding: false,
            label: 'Last Name',
        },
        {
            field: 'email',
            type: '',
            sort: true,
            disablePadding: false,
            label: 'Email',
        },

        {
            field: 'created_at',
            type: 'datetime',
            sort: true,
            disablePadding: false,
            label: 'Sent on',
        },
        {
            field: 'action',
            type: 'button',
            clickType: 'visibility',
            buttonType: 'visibility',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'View',
        },
    ]

    const searchInfo = [
        {
            label: 'Email',
            placeholder: 'Enter Email',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'email',
            formik: formik,
        },
    ]

    const validationArray = Yup.object({})

    const formikEdit = useFormik({
        initialValues: {
            id: 0,
            table: 'contact_us',
            wine_club_level: '',
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            address1: '',
            address2: '',
            country: global.defaultCountry,
            city: '',
            state: '',
            zip: '',
            refer_email: '',
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            console.log('+++++++++++++', values)
            searchTableAction(values)
        },
    })

    const resetFrom = () => {
        console.log('resetForm')
        formikEdit.setFieldValue('id', 0)
        formikEdit.setFieldValue('wine_club_level', '')
        formikEdit.setFieldValue('first_name', '')
        formikEdit.setFieldValue('last_name', '')
        formikEdit.setFieldValue('email', '')
        formikEdit.setFieldValue('phone', '')
        formikEdit.setFieldValue('address1', '')
        formikEdit.setFieldValue('address2', '')
        formikEdit.setFieldValue('country', global.defaultCountry)
        formikEdit.setFieldValue('city', '')
        formikEdit.setFieldValue('state', '')
        formikEdit.setFieldValue('zip', '')
        formikEdit.setFieldValue('refer_email', '')
        formikEdit.setFieldValue('table', 'contact_us')
    }

    useEffect(() => {
        console.log('manage', manage)
        if (manage.status === 'edit') {
            formikEdit.setFieldValue('id', manage.id)
            const template = tableBody.filter((cat) => cat.id === manage.id)
            console.log('template', template)
            formikEdit.setFieldValue(
                'wine_club_level',
                template[0].wine_club_level
            )
            formikEdit.setFieldValue('first_name', template[0].first_name)
            formikEdit.setFieldValue('last_name', template[0].last_name)
            formikEdit.setFieldValue('email', template[0].email)
            formikEdit.setFieldValue('phone', template[0].phone)
            formikEdit.setFieldValue('address1', template[0].address1)
            formikEdit.setFieldValue('address2', template[0].address2)
            formikEdit.setFieldValue('country', template[0].country)
            formikEdit.setFieldValue('city', template[0].city)
            formikEdit.setFieldValue('state', template[0].state)
            formikEdit.setFieldValue('zip', template[0].zip)
            formikEdit.setFieldValue('refer_email', template[0].refer_email)
            setReload(!reload)
        } else {
            resetFrom()
        }
    }, [manage])

    const contactInfo = {
        formik: formikEdit,
        data: [
            {
                title: 'TCWC Wine Club Level',
                type: 'radio',
                name: 'wine_club_level',
                class: 'col-12',
                int: 1,
                item: [
                    { id: '1', description: 'Enthusiast ($899/shipment)' },
                    {
                        id: '2',
                        description: 'Aficionado Club ($1,799/shipment)',
                    },
                ],
            },
            {
                label: 'First name',
                name: 'first_name',
                type: 'text',
                placeholder: 'Enter your first name',
                class: 'col-sm-6 col-12',
            },
            {
                label: 'Last name',
                name: 'last_name',
                type: 'text',
                placeholder: 'Enter your last name',
                class: 'col-sm-6 col-12',
            },
            {
                label: 'Email address',
                name: 'email',
                type: 'text',
                placeholder: 'Enter your email address',
                class: 'col-12',
            },
            {
                label: 'Phone number',
                name: 'phone',
                type: 'number',
                placeholder: 'Phone number',
                class: 'col-12',
            },
            {
                label: 'Address Line 1 *',
                name: 'address1',
                type: 'text',
                placeholder: 'Enter address line 1',
                class: 'col-12 col-sm-6',
            },
            {
                label: 'Address Line 2 *',
                name: 'address2',
                type: 'text',
                placeholder: 'Enter address line 2',
                class: 'col-12 col-sm-6',
            },
            {
                label: 'Country *',
                placeholder: 'Select your country',
                class: 'col-12 col-sm-6',
                type: 'select',
                options: allCountries
                    .filter(
                        (country) =>
                            global.ignoreCountry.indexOf(country.isoCode) === -1
                    )
                    .map((country) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = country.name
                        busCategoryChanged.value = country.isoCode
                        return busCategoryChanged
                    }),
                name: 'country',
            },
            {
                label: 'State *',
                placeholder: 'Select your state',
                class: 'col-12 col-sm-6',
                type: 'select',
                options: allStates
                    .filter(
                        (state) =>
                            (formik.values.country
                                ? formik.values.country.indexOf(
                                      state.countryCode
                                  ) !== -1
                                : global.defaultCountry.indexOf(
                                      state.countryCode
                                  ) !== -1) &&
                            global.ignoreStates.indexOf(state.isoCode) === -1
                    )
                    .map((buscat) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = buscat.name
                        busCategoryChanged.value = buscat.isoCode
                        return busCategoryChanged
                    }),
                name: 'state',
            },
            {
                label: 'City *',
                name: 'city',
                type: 'text',
                placeholder: 'Enter your city',
                class: 'col-12 col-sm-6',
            },
            {
                label: 'Zip *',
                placeholder: 'Ente your zip',
                class: 'col-12 col-sm-6',
                type: 'text',
                name: 'zip',
            },
            {
                label: 'Referred By (email address)',
                name: 'refer_email',
                type: 'text',
                placeholder: 'Enter the reffered by email address',
                class: 'col-12',
            },
        ],
    }

    return (
        <Layout>
            <div className="dashboard communications">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={[]}
                    allData={table_data}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={searchTable}
                />
                <FullScreenPopup
                    modaltitle={
                        manage.status === 'new'
                            ? 'Add New Vat'
                            : 'View Wine Club Form'
                    }
                    open={manage.popup}
                    handleClose={() => toggleFullScreenPopup(false, 'new', 0)}
                >
                    <div className="dashboard addNewListing mt-4">
                        <div className="fspBody">
                            <form
                                onSubmit={formikEdit.handleSubmit}
                                autoComplete="nofill"
                            >
                                <div className="row">
                                    {mapData(contactInfo)}
                                </div>
                                <div className="actionButton d-flex justify-content-center align-items-center">
                                    {/* <SecondaryButton
                                        label="Reset"
                                        type="reset"
                                        onClick={() => resetFrom()}
                                    /> */}
                                    {/* <PrimaryButton type="submit" label="Submit" /> */}
                                </div>
                            </form>
                        </div>
                    </div>
                </FullScreenPopup>
            </div>
        </Layout>
    )
}
export default SubscribeInfo
